import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';

import {DialogAddRows} from '../dilog/add-rows.component';
import {MatDialog} from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {Papa} from 'ngx-papaparse';
import {SharedService} from '../../shared.service';
import { ApiCallStatusService } from 'src/app/services/api-call-status.service';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

declare var $: any;





@Component({
  standalone: false,
    selector: 'app-add-form-qty',
    templateUrl: './add-form-qty.component.html',
    styleUrls: ['./add-form-qty.component.scss']
})
export class AddFormQtyComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit{
    gridData: any[] = [];
    

    requestForm: FormGroup;
    @Input() dataSource: any;
    @Output() optSelected: EventEmitter<any> = new EventEmitter();
    @ViewChild('addGrid', { static: false }) addGrid!: DxDataGridComponent;
    @Input() itemCatalogGroupId: any;
    @Input() itemCatalogId: any;
    @Input() focalId: any;
    @Input() itemTypeMasterId: any;
    @Input() companyBranchId: any;
    @Input() acknowledgement: any;
    loadingIndicator: boolean;
    showGenerateBtn: boolean;
    SPH_RANGE = [];
    ADD_RANGE = [];
    rangeStockListPayload = [];
    isEdit: boolean;
    isCsv: boolean;
    gridColumns: any[] = [];
    actionSheetVisible: boolean;
    actionSheetTarget: any;
    readonly: boolean;
    isAllZero: boolean;
    templist: any;
    previousStock: boolean;
    crrentStock: number;
    sphError: boolean;
    addError: boolean;
    stockIcon: boolean;
    inputType: boolean;
    totalQTY: number;
    availableStock: number;
    loadingStockAvailable: boolean;
    displayOnly: boolean;
    rangeLoading: boolean;
    showPreviousStock: boolean;
    loadingAllAvailableStock: boolean;
    hideClearBtn: boolean;
    totalToggle: boolean;
    isPreviousStockValueSetInput: boolean;
    constructor (
        private sharedService: SharedService,
        public dialog: MatDialog,
        private papa: Papa,
        private apiCallStatusSrvs: ApiCallStatusService
    ) {
    }
    isApiInProgress$ = this.apiCallStatusSrvs.isApiInProgress$;
    private availableStockCache = new Map<string, any[]>();
    private previousStockMap = new Map<string, number>();
    ngOnInit() {
        this.totalQTY = 0;
        this.availableStock = 0;
       
        // this.showGenerateBtn = false;
        // this.displayOnly = false;
    }

    /** Map vendorItemCode -> ids from any existing sources (edit identity). */

    /** Rebuild rangeStockListPayload from the current grid content (keeps ids). */
    private rebuildDetailsFromGrid(): void {
        const byCell = this.existingDetailLookup();
        const out: any[] = [];

        for (const row of this.gridData || []) {
            const sph = this.normN(row.sph);
            for (let c = 0; c < (this.ADD_RANGE?.length || 0); c++) {
                const addf = this.normN(this.ADD_RANGE[c]);
                const qty = this.parseQty(row['add_' + c]);
                const key = this.makeKey(sph, addf);
                const ids = byCell.get(key) || {};

                if (qty !== null) {
                    out.push({
                        vendorItemCode: qty,
                        addf, sph,
                        vendorItemCatalogId: Number(ids.vendorItemCatalogId || 0),
                        vendorItemCatalogDetailId: Number(ids.vendorItemCatalogDetailId || 0),
                        status: 'active',
                        active: true,
                    });
                }
            }
        }

        this.rangeStockListPayload = out;
        this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    }


   

    /** Scan a 2D snapshot (gridData-like) and return duplicate barcodes (unique list). */
    private hasDuplicateInSnapshot(snapshotRows: any[]): string[] {
        return [];
    }

    /** Find duplicate barcodes among ACTIVE rows in details array. */
    private findDuplicateInDetails(details: any[] = []): string[] {
        return [];
    }

    prepareGridColumns() {
        this.gridColumns = [
            { 
                dataField: 'sph',
                caption: 'SPH / ADD',
                allowEditing: false,
                width: 120,
                dataType: 'number',
                format: { type: 'fixedPoint', precision: 2 },
                alignment: 'right'
            },
            ...this.ADD_RANGE.map((add, idx) => ({
                dataField: `add_${idx}`,
                caption: Number(add).toFixed(2),
                dataType: 'string',
                width: 100,
                alignment: 'right',
                cssClass: 'add-col',
            }))
        ];
    }


    prepareGridData() {
        if (!this.SPH_RANGE || !this.ADD_RANGE) return;

        this.gridData = this.SPH_RANGE.map((sph) => {
            const row: any = { sph };
            this.ADD_RANGE.forEach((_, addIdx) => {
                row['add_' + addIdx] = '';
            });
            return row;
        });

        // always try to seed from the freshest payload pushed in by parent
        const incomingPayload = Array.isArray(this.dataSource?.rangeStockListPayload)
            ? this.dataSource.rangeStockListPayload
            : null;
        const fallbackPayload = Array.isArray(this.templist) ? this.templist : null;
        this.seedFromExistingPayload(incomingPayload ?? fallbackPayload ?? []);
    }

    ngAfterViewInit() {
        $(document).ready(() => {
            var element = null;
            $('table tr td input').focus((e) => {
               element =  e.target.parentNode.parentNode.parentNode;
               $(element).find('th').css('background-color', 'lightgreen');
            }).blur(() => {
               $(element).find('th').css('background-color', 'inherit');
            })
        })
    }
    /**
     * @name itemClick
     * @param sphIndex 
     * @param addlIndex 
     * @returns previousStock and crrentStock 
     */
    // itemClick(sphIndex, addlIndex) {
    //     const elementIndex = sphIndex + '-' + addlIndex;
    //     this.actionSheetTarget = '#img-' + elementIndex;
    //     this.actionSheetVisible = true;
    //     this.previousStock = 0;
    //     this.crrentStock = 0;
    //     if (this.templist &&  this.templist.length > 0) {
    //         this.templist.forEach(data => {
    //             // tslint:disable-next-line:triple-equals
    //         let sph = data.sph.toFixed(2).toString();
    //         let addf = data.addf.toFixed(2).toString();
    //             if (sph == this.SPH_RANGE[sphIndex] && addf == this.ADD_RANGE[addlIndex]) {
    //                 this.previousStock = data.previousStock ? data.previousStock : 0;
    //                 this.crrentStock = data.crrentStock ? data.crrentStock : 0;
    //                 return ;
    //             }
    //         });
    //     }
    // }
     /**
     * @name getAvailableStock
     * @param {*} e
     * @param {*} sph
     * @param {*} cyl
     * @memberof CylFormComponent
     */
    getAvailableStock(e, sph: any, add: any) {
        this.availableStock = 0;
        this.loadingStockAvailable = true;
        let payload = {
            itemCatalogGroupId: this.itemCatalogGroupId,
            sph: sph,
            cylOrAdd: add 
        };
        this.sharedService.getAvailableStock(payload)
            .then((response: any) => {
                if (response.data.completed) {
                    this.loadingStockAvailable = false;
                    this.availableStock = response.data.payload;
                    console.log('getAvailableStock', response.data.payload);
                    this.actionSheetTarget = '#img-' + e;
                    this.actionSheetVisible = true;
                } else {
                    this.loadingStockAvailable = false;
                    this.availableStock = 0;
                    console.error(response);
                }
            })
            .catch(error => {
                this.availableStock = 0;
                this.loadingStockAvailable = false;
                console.log(error);

            });

    }
    // readCSV(event) {
    //     const files: FileList = event.target.files;
    //     if (files && files.length > 0) {
    //         const file: File = files.item(0);
    //         const reader: FileReader = new FileReader();
    //         reader.readAsText(file);
    //         reader.onload = (e) => {
    //             const csvData: string = reader.result as string;
    //             // console.log(csvData);
    //             this.papa.parse(csvData, {
    //                 complete: (result) => {
    //                     // console.log('Parsed: ', result);
    //                     result.data.map((parentArray, parentArrayIndex) => {
    //                         parentArray.map((value, childArrayIndex) => {
    //                             $('table tr td #input-' + parentArrayIndex + '-' + childArrayIndex).val(value);
    //                             this.getRangeValues(value, this.ADD_RANGE[childArrayIndex], this.SPH_RANGE[parentArrayIndex]);
    //                         });
    //                     });
    //                 }
    //             });
    //         };
    //     }
    // }
    // ðŸ‘‰ Upload CSV
    // ===== CSV HELPERS (plain JS, no PapaParse) =====
    private splitCsvLine(line: string): string[] { /* unchanged from your file */
        const result: string[] = [];
        let cur = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
            const ch = line[i];
            if (ch === '"') {
                if (inQuotes && line[i + 1] === '"') { cur += '"'; i++; }
                else { inQuotes = !inQuotes; }
            } else if (ch === ',' && !inQuotes) {
                result.push(cur); cur = '';
            } else {
                cur += ch;
            }
        }
        result.push(cur);
        return result.map(v => v.trim());
    }

    private parseCsv(text: string): string[][] {
        const clean = text.replace(/^\uFEFF/, '');
        return clean.split(/\r?\n/)
            .map(r => r.replace(/\r$/, ''))
            .filter(r => r.trim() !== '')
            .map(r => this.splitCsvLine(r));
    }

    // ===== CSV read (with duplicate cleanup) =====
    readCSV(event: any) {
        const file: File = event?.target?.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            const csvText = String(reader.result ?? '');
            const rows = this.parseCsv(csvText);
            if (!rows.length) return;

            // Header row
            const header = rows[0];
            const addHeadersRaw = header.slice(1).filter(h => h !== '');
            const addHeaders = addHeadersRaw.map(h => Number(h)).filter(v => !Number.isNaN(v));

            // Rows
            const newGrid: any[] = [];
            const sphRange: number[] = [];
            rows.slice(1).forEach((cells) => {
                if (!cells.length || (cells.length === 1 && cells[0] === '')) return;
                const sph = Number(cells[0]);
                if (Number.isNaN(sph)) return;
                const rowObj: any = { sph };
                addHeaders.forEach((_, idx) => {
                    rowObj['add_' + idx] = (cells[idx + 1] ?? '').toString();
                });
                sphRange.push(sph);
                newGrid.push(rowObj);
            });

            // Set state
            this.ADD_RANGE = addHeaders;
            this.SPH_RANGE = sphRange;
            this.prepareGridColumns();
            this.gridData = newGrid;

            // Bring payload in sync
            this.rangeStockListPayload = [];
            for (let r = 0; r < this.SPH_RANGE.length; r++) {
                for (let c = 0; c < this.ADD_RANGE.length; c++) {
                    const v = this.gridData[r]['add_' + c];
                    if (v !== '' && v != null) {
                        this.getRangeValues(v, this.ADD_RANGE[c], this.SPH_RANGE[r]);
                    }
                }
            }

            // Duplicate cleanup after CSV
            const dups = this.hasDuplicateInSnapshot(this.gridData);
            if (dups.length) {
                notify({
                    message: `CSV contains duplicate barcode${dups.length > 1 ? 's' : ''}: ${dups.slice(0, 6).join(', ')}${dups.length > 6 ? '…' : ''}. Later duplicates were cleared.`,
                    type: 'error',
                    width: 460,
                    displayTime: 4500
                });
                // Clear later duplicates visually and from payload
                const seen = new Set<string>();
                for (const row of this.gridData) {
                    for (let c = 0; c < this.ADD_RANGE.length; c++) {
                        const f = 'add_' + c;
                        const code = this.normalizeCode(row[f]);
                        if (!code) continue;
                        if (seen.has(code)) {
                            row[f] = '';
                            this.getRangeValues('', this.ADD_RANGE[c], row.sph); // mark inactive/clear
                        } else {
                            seen.add(code);
                        }
                    }
                }
            }

            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
            if (event?.target) event.target.value = '';
        };
        reader.readAsText(file);
    }


    // ====== EXPORT CSV (from ADD_RANGE, SPH_RANGE, gridData) ======
    exportToCsv() {
        if (!this.gridData?.length || !this.ADD_RANGE?.length || !this.SPH_RANGE?.length) {
            alert('No data to export');
            return;
        }

        // Header
        let csv = 'SPH / ADD,' + this.ADD_RANGE.join(',') + '\n';

        // Rows
        for (let r = 0; r < this.SPH_RANGE.length; r++) {
            const sph = this.SPH_RANGE[r];
            const cells: string[] = [String(sph)];
            for (let c = 0; c < this.ADD_RANGE.length; c++) {
                const val = this.gridData[r]['add_' + c] ?? '';
                // Quote if needed
                const needsQuote = /[",\n]/.test(String(val));
                const safeVal = needsQuote ? `"${String(val).replace(/"/g, '""')}"` : String(val);
                cells.push(safeVal);
            }
            csv += cells.join(',') + '\n';
        }

        // Download
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'StockGrid.csv';
        a.click();
        URL.revokeObjectURL(a.href);
    }





    // ðŸ‘‰ Export CSV
    // exportToCsv() {
    //     if (!this.gridData?.length) {
    //         alert('No data to export');
    //         return;
    //     }

    //     // Header row: "SPH / ADD, add1, add2, ..."
    //     let csvContent = 'SPH / ADD,' + this.ADD_RANGE.join(',') + '\n';

    //     this.gridData.forEach((row) => {
    //         const rowVals = [row.sph];
    //         this.ADD_RANGE.forEach((_, idx) => {
    //             rowVals.push(row['add_' + idx] ?? '');
    //         });
    //         csvContent += rowVals.join(',') + '\n';
    //     });

    //     // Download
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    //     const link = document.createElement('a');
    //     link.href = URL.createObjectURL(blob);
    //     link.download = 'StockGrid.csv';
    //     link.click();
    // }

    /**
     * @name getInitForm
     * @description init form
     * @return form controls
     */
    getInitForm() {
        this.requestForm = new FormGroup({
            sections: new FormArray([])
        });
    }

    /**
     // tslint:disable-next-line: no-redundant-jsdoc
     * @description ngOnChanges
     * @desc Fires when change in input properties are detected
     * @return void
     */
    ngOnChanges(changes: SimpleChanges) {
        this.getInitForm();
        this.availableStockCache.clear();
        if (Object.keys(changes.dataSource.currentValue).length > 0) {
            this.rangeStockListPayload = [];
            this.isAllZero = false;
            // console.log('Add', changes.dataSource.currentValue);
            this.inputType = changes.dataSource.currentValue.inputType;
            this.stockIcon = changes.dataSource.currentValue.stockIcon;
            this.displayOnly = changes.dataSource.currentValue.displayOnly;
            this.showPreviousStock = changes.dataSource.currentValue.showPreviousStock;
            this.hideClearBtn = changes.dataSource.currentValue.hideClearBtn;
            this.readonly = changes.dataSource.currentValue.readonly;
             this.totalToggle = changes.dataSource.currentValue.totalToggle;
             this.showGenerateBtn = changes.dataSource.currentValue.generateBtn;
             this.isPreviousStockValueSetInput = changes.dataSource.currentValue.isPreviousStockValueSetInput;
            this.templist = Array.isArray(changes.dataSource.currentValue.rangeStockListPayload)
                ? changes.dataSource.currentValue.rangeStockListPayload
                : null;
            this.addSection(changes.dataSource.currentValue);

             if (!this.showGenerateBtn) {
                this.checkRange();
            }
            if (changes.dataSource.currentValue.isEdit) {
                if (changes.dataSource.currentValue.rangeStockListPayload) {
                    this.setInventoryFormData(changes.dataSource.currentValue.rangeStockListPayload);
                }
                this.isEdit = true;
                this.isPreviousStockValueSetInput = false;
                this.readonly = changes.dataSource.currentValue.readonly;
                this.isAllZero = changes.dataSource.currentValue.isAllZero;
            }
            if (changes.dataSource.currentValue.rangeOption) {
                const payload = {
                    itemCatalogGroupId: this.itemCatalogGroupId,
                    itemTypeMasterId: this.itemTypeMasterId,
                    focalId: this.focalId,
                    sphmin: (changes.dataSource.currentValue.barCodeData.sphmin || changes.dataSource.currentValue.barCodeData.sphmin == 0) ? changes.dataSource.currentValue.barCodeData.sphmin : 0,
                    sphmax: (changes.dataSource.currentValue.barCodeData.sphmax || changes.dataSource.currentValue.barCodeData.sphmax == 0)  ? changes.dataSource.currentValue.barCodeData.sphmax : 0,
                    cylmin: (changes.dataSource.currentValue.barCodeData.cylmin || changes.dataSource.currentValue.barCodeData.cylmin == 0)  ? changes.dataSource.currentValue.barCodeData.cylmin : 0,
                    cylmax: (changes.dataSource.currentValue.barCodeData.cylmax || changes.dataSource.currentValue.barCodeData.cylmax == 0) ? changes.dataSource.currentValue.barCodeData.cylmax : 0,
                    addmin: (changes.dataSource.currentValue.barCodeData.addmin || changes.dataSource.currentValue.barCodeData.addmin == 0)  ? changes.dataSource.currentValue.barCodeData.addmin : 0,
                    addmax: (changes.dataSource.currentValue.barCodeData.addmax || changes.dataSource.currentValue.barCodeData.addmax == 0) ? changes.dataSource.currentValue.barCodeData.addmax : 0,
                    cxmin:  (changes.dataSource.currentValue.barCodeData.cxmin || changes.dataSource.currentValue.barCodeData.cxmin == 0) ? changes.dataSource.currentValue.barCodeData.cxmin : 0,
                    cxmax:  (changes.dataSource.currentValue.barCodeData.cxmax || changes.dataSource.currentValue.barCodeData.cxmax == 0) ? changes.dataSource.currentValue.barCodeData.cxmax : 0
                };
                this.validateBarcodeRequestRange(payload);
            }
        }
    }

    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description addSection
     // tslint:disable-next-line:no-redundant-jsdoc
     // tslint:disable-next-line:no-redundant-jsdoc
     * @params data
     * @returns void
     * @description create section array
     */
    addSection(data?: any): void {
        if (data) {
            if (data.active) {
                // console.log(data);
                this.showGenerateBtn = data.generateBtn;
                this.isCsv = data.csv;
                const sectionsList = this.requestForm.get('sections') as FormArray;
                sectionsList.push(this.createSection(data));
            }
        }
    }

    /**
      // tslint:disable-next-line:no-redundant-jsdoc
     * @description createSection
     * @params data
     * @return FormGroup
     * @description section controls
     */
    createSection(data?: any): FormGroup {
        return new FormGroup({
            condition: new FormControl(data ? data.condition : '', []),
            active: new FormControl(data ? data.active : false, []),
            childern: new FormArray(this.addChildern(data.childern)),
        });
    }

    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description addChildern
     * @params data
     * @returns childern array
     */
    addChildern(data?: any) {
        const formArray = [];
        data.forEach(child => {
            formArray.push(this.createChild(child));
        });
        return formArray;
    }

    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description createChild
     * @params child
     * @return  childer controls
     * @deprecated child formcontrols
     */
    createChild(child?): FormGroup {
        return new FormGroup({
            name: new FormControl(child ? child.name : '', []),
            min: new FormControl(child ? child.min : '', [Validators.required]),
            max: new FormControl(child ? child.max : '', [Validators.required]),
            valueType: new FormControl(child.valueType, [])
        });
    }

    /**
     * @description sectionsArray
     * @returns section array controls
     */
    get sectionsArray() {
        return this.requestForm.get('sections') as FormArray;
    }

    /**
     * @description getChildern
     * @params form section item index
     * @returns childern array controls
     */
    getChildern(form) {
        return form.controls.childern.controls;
    }

    saveStockRequest(requestForm: FormGroup) {
        this.loadingIndicator = true;

        // Commit any open editor, then rebuild details from snapshot
        try {
            this.addGrid?.instance.saveEditData();
            this.addGrid?.instance.closeEditCell?.();
        } catch { }
        this.rebuildDetailsFromGrid();

        // Kill-switch for duplicate barcodes
        const dups = this.findDuplicateInDetails(this.rangeStockListPayload);
        if (dups.length) {
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} found: ${dups.slice(0, 8).join(', ')}${dups.length > 8 ? '…' : ''}. Remove duplicates before saving.`,
                type: 'error', width: 460, displayTime: 4500
            });
            this.loadingIndicator = false;
            return;
        }

        // Build the same summary you already send
        const sections = this.sectionsArray as FormArray;
        const children = sections.at(0).get('childern') as FormArray;

        const sph_min = children.at(0).get('min').value;
        const sph_max = children.at(0).get('max').value;
        const add_min = children.at(1).get('min').value;
        const add_max = children.at(1).get('max').value;
        const sph_valueType = children.at(0).get('valueType').value;
        const add_valueType = children.at(1).get('valueType').value;

        const payload = {
            sphmin: sph_valueType ? -sph_min : sph_min,
            sphmax: sph_valueType ? -sph_max : sph_max,
            addmin: add_valueType ? -add_min : add_min,
            addmax: add_valueType ? -add_max : add_max,
            // Only send active rows; backend handles deletions
            rangeStockListPayload: (this.rangeStockListPayload || []).filter(x => x && (x.vendorItemCode ?? '') !== ''),
            totalQTY: this.totalQTY
        };

        if (requestForm.invalid) { this.loadingIndicator = false; return false; }

        // Debug once if helpful
        // console.log('[ADD save] details:', this.rangeStockListPayload.length, this.rangeStockListPayload.slice(0,3));

        this.optSelected.emit(payload);
        setTimeout(() => { this.loadingIndicator = false; }, 300);
    }



    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description clearField
     * @return void
     */
    clearField(): void {
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').setValue('');
        ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue('');
        // const child = (this.requestForm.get('sections') as FormArray).at(0).get('childern') as FormArray;
        // while (child.length !== 0) {
        //     child.removeAt(0);
        // }
        this.rangeStockListPayload = [];
        this.SPH_RANGE = [];
        this.ADD_RANGE = [];
    }

    /**
     * @description addRows
     * @return number of rows
     * @description modal popup
     */
    addRows() {
        const dialogRef = this.dialog.open(DialogAddRows, {
            width: '250px',
            data: {label: 'ADD'}
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log('The dialog was closed', result);
            if (result.rows) {
                // tslint:disable-next-line:radix
                for (let i = 0; i < parseInt(result.rows); i++) {
                    // this.createCxTypeDetail();
                    this.updatedMaxVal('increment');
                }
            }
        });
    }

    /**
     * @description incrementMaxVal
     * @returns updated max value
     */
    updatedMaxVal(label: string) {
        const val = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
        if (label === 'increment') {
            // tslint:disable-next-line:radix
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) + 1);
            // tslint:disable-next-line:radix
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) + 1);
        }
        if (label === 'decrement') {
            // tslint:disable-next-line:radix
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').setValue(parseInt(val) - 1);
            // tslint:disable-next-line:radix
            ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').setValue(parseInt(val) - 1);
        }
    }

    /**
     * @description removeIndex
     // tslint:disable-next-line:no-redundant-jsdoc
     * @params index
     * @return void
     * @description removing row index
     */
    removeIndex(index) {
        // this.SPH_RANGE.splice(index, 1);
        // this.CYL_RANGE.splice(index, 1);
        // const item = (this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray;
        // item.removeAt(index);
        this.updatedMaxVal('decrement');
        // ((this.requestForm.get('sections') as FormArray).at(0).get('cxTypeDetail') as FormArray).removeAt(index);
    }

    // getRangeValues(val, addf, sph, hiddenId?: any) {
    //     if (!val && this.isAllZero) {
    //         // if value empty then remove it from collection
    //         for (let i = 0; i < this.rangeStockListPayload.length; i++) {
    //             if (
    //                 this.rangeStockListPayload[i].addf === addf &&
    //                 this.rangeStockListPayload[i].sph === sph
    //             ) {
    //                 this.rangeStockListPayload.splice(i, 1);
    //                 break;
    //             }
    //         }
    //         this.totalQTY  = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    //         // console.log('if value empty then remove it from collection ', this.rangeStockListPayload);
    //         return;
    //     }

    //     // check whether the value already exist then modify it
    //     if (this.rangeStockListPayload.some(o => o.addf === addf && o.sph === sph)) {
    //         for (let i = 0; i < this.rangeStockListPayload.length; i++) {
    //             if (
    //                 this.rangeStockListPayload[i].addf === addf &&
    //                 this.rangeStockListPayload[i].sph === sph && val
    //             ) {
    //                 this.rangeStockListPayload[i]['vendorItemCode'] = val;
    //                 break;
    //             }
    //         }
    //         this.totalQTY  = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    //     } else {
    //         // else not found so push it
    //         const rangePairObj = {
    //             cx: null,
    //             cxtypeId: null,
    //             vendorItemCode: val,
    //             cc: null,
    //             addf: addf,
    //             axis: null,
    //             cyl: null,
    //             ct: null,
    //             et: null,
    //             tc: null,
    //             wt: null,
    //             sph: sph,
    //             vendorItemCatalogId: hiddenId
    //         };
    //         this.rangeStockListPayload.push(rangePairObj);
    //         this.totalQTY  = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    //     }
    //     // console.log('Else range ', this.rangeStockListPayload);
    // }
    getRangeValues(
        val: any,
        addf: number,
        sph: number,
        identity?: number | { vendorItemCatalogId?: number; vendorItemCatalogDetailId?: number }
    ) {
        const nSph = this.normN(sph);
        const nAddf = this.normN(addf);
        const idx = this.rangeStockListPayload.findIndex(
            i => this.normN(i.addf) === nAddf && this.normN(i.sph) === nSph
        );

        // Accept either a numeric (legacy hidden input) or an object with both ids
        const ids = (typeof identity === 'object' && identity !== null)
            ? {
                vendorItemCatalogId: Number(identity.vendorItemCatalogId || 0),
                vendorItemCatalogDetailId: Number(identity.vendorItemCatalogDetailId || 0),
            }
            : {
                vendorItemCatalogId: Number(identity || 0),
                vendorItemCatalogDetailId: 0,
            };

        const fromLookup = this.existingDetailLookup().get(this.makeKey(nSph, nAddf)) || {};
        const assignIds = (obj: any) => {
            obj.vendorItemCatalogId = Number(obj.vendorItemCatalogId || ids.vendorItemCatalogId || fromLookup.vendorItemCatalogId || 0);
            obj.vendorItemCatalogDetailId = Number(obj.vendorItemCatalogDetailId || ids.vendorItemCatalogDetailId || fromLookup.vendorItemCatalogDetailId || 0);
        };

        const qty = this.parseQty(val);

        if (qty === null) {
            if (idx !== -1) {
                this.rangeStockListPayload.splice(idx, 1);
            }
            this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
            return;
        }

        if (idx !== -1) {
            this.rangeStockListPayload[idx].vendorItemCode = qty;
            this.rangeStockListPayload[idx].status = 'active';
            assignIds(this.rangeStockListPayload[idx]);
        } else {
            const obj: any = {
                vendorItemCode: qty,
                addf: nAddf,
                sph: nSph,
                vendorItemCatalogId: 0,
                vendorItemCatalogDetailId: 0,
                status: 'active',
            };
            assignIds(obj);
            this.rangeStockListPayload.push(obj);
        }

        this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    }


    checkRange() {
        // reset ranges
        this.SPH_RANGE = [];
        this.ADD_RANGE = [];

        const sections = this.sectionsArray as FormArray;
        const children = sections?.at(0)?.get('childern') as FormArray;

        const sph_min = children?.at(0)?.get('min')?.value;
        const sph_max = children?.at(0)?.get('max')?.value;
        const sph_valueType = children?.at(0)?.get('valueType')?.value;

        const add_min = children?.at(1)?.get('min')?.value;
        const add_max = children?.at(1)?.get('max')?.value;
        const add_valueType = children?.at(1)?.get('valueType')?.value;

        // --- SPH validation & range ---
        if (sph_max < sph_min) {
            this.sphError = true;
            return;
        } else {
            this.sphError = false;

            if ((sph_min && sph_max) || (sph_min === 0 && sph_max) || (sph_min === 0 && sph_max === 0)) {
                // handle negative-direction ranges when valueType is true
                const sphStart = sph_valueType ? -Number(sph_max) : Number(sph_min);
                const sphEnd = sph_valueType ? -Number(sph_min) : Number(sph_max);
                this.SPH_RANGE = this.sharedService.generateRange(sphStart, sphEnd, 0.25);
                if (sph_valueType) this.SPH_RANGE.reverse();
            } else {
                this.SPH_RANGE = null;
            }
        }

        // --- ADD validation & range ---
        if (add_max < add_min) {
            this.addError = true;
            return;
        } else {
            this.addError = false;

            if ((add_min && add_max) || (add_min === 0 && add_max) || (add_min === 0 && add_max === 0)) {
                const addStart = add_valueType ? -Number(add_max) : Number(add_min);
                const addEnd = add_valueType ? -Number(add_min) : Number(add_max);
                this.ADD_RANGE = this.sharedService.generateRange(addStart, addEnd, 0.25);
                if (add_valueType) this.ADD_RANGE.reverse();
            } else {
                this.ADD_RANGE = null;
            }
        }

        // --- Rebuild grid (columns + rows) and seed existing payload ---
        this.prepareGridColumns();
        this.prepareGridData();           // seeds from this.templist / dataSource if present
        this.addGrid?.instance?.refresh?.();

        // --- Recompute totals based on current payload ---
        this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');

        // --- Optional: immediate duplicate warning on regenerated grid (does not clear values) ---
        const dups = this.hasDuplicateInSnapshot(this.gridData || []);
        if (dups?.length) {
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} detected: ${dups.slice(0, 6).join(', ')}${dups.length > 6 ? '…' : ''}. Please ensure all barcodes are unique.`,
                type: 'error',
                width: 460,
                displayTime: 4500
            });
        }
    }

    calculateTotalSummary(e: any) {
        if (e?.name !== 'totalQty') {
            return;
        }
        if (e.summaryProcess === 'start') {
            e.totalValue = 0;
            return;
        }
        if (e.summaryProcess === 'finalize') {
            e.totalValue = Number(this.totalQTY) || 0;
        }
    }


    // DevExtreme editing hooks
    onEditorPreparing(e: any) {
        if (e.parentType !== 'dataRow') return;
        if (e.dataField === 'sph') {
            e.editorOptions.readOnly = true;
        }
    }
    onSaving(e: any) {
        // Make a snapshot and apply pending changes
        const snapshot = (this.gridData || []).map(r => ({ ...r }));
        for (const ch of (e.changes || [])) {
            if (ch.type === 'update') {
                const rowIndex = snapshot.findIndex(r => r.sph === (ch.key?.sph ?? ch.key));
                if (rowIndex >= 0) {
                    Object.keys(ch.data || {}).forEach(df => {
                        snapshot[rowIndex][df] = ch.data[df];
                    });
                }
            }
        }
        const dups = this.hasDuplicateInSnapshot(snapshot);
        if (dups.length) {
            e.cancel = true;
            notify({
                message: `Duplicate barcode${dups.length > 1 ? 's' : ''} detected: ${dups.slice(0, 6).join(', ')}${dups.length > 6 ? '…' : ''}. Please ensure all barcodes are unique.`,
                type: 'error',
                width: 460,
                displayTime: 4500
            });
        }
    }
    onCellValueChanged(e: any) {
        if (!e?.column || e.column.dataField === 'sph') return;
        const field: string = e.column.dataField;
        const match = field.match(/^add_(\d+)$/);
        if (!match) return;
        const addIdx = Number(match[1]);
        const addVal = this.ADD_RANGE?.[addIdx];
        const sphVal = e.data?.sph;
        const val = e.value;
        if (typeof addVal === 'undefined' || typeof sphVal === 'undefined') return;

        // keep payload in sync
        this.getRangeValues(val, addVal, sphVal);
        this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    }

    onCellPrepared(e: any) {
        if (e.rowType !== 'data') return;
        if (e.column?.dataField === 'sph') return;
        const cell = e.cellElement as HTMLElement;
        const addField = e.column?.dataField ?? '';
        const addIndex = this.parseAddField(addField);
        if (addIndex === -1) {
            this.renderBadge(cell, 'prev-stock-chip', null);
            return;
        }

        const addValue = this.ADD_RANGE?.[addIndex];
        const sph = e.data?.sph;
        const key = this.buildCellKey(sph, addValue);
        const prevValue = this.previousStock ? this.previousStockMap.get(key) : null;
        this.renderBadge(cell, 'prev-stock-chip', prevValue);
    }

    toggleStock(label: string, change?: MatSlideToggleChange) {
        switch (label) {
            case 'previous': {
                const nextState = typeof change?.checked === 'boolean' ? change.checked : !this.previousStock;
                const stateChanged = nextState !== this.previousStock;

                if (change && !stateChanged) {
                    return;
                }

                this.previousStock = nextState;
                if (!this.previousStock) {
                    this.previousStockMap.clear();
                    this.refreshGridBadges();
                    return;
                }

                const isPositiveRange = this.isPositiveRange();
                const cacheKey = this.buildAvailableStockCacheKey(this.companyBranchId, this.itemCatalogGroupId, isPositiveRange);

                if (this.availableStockCache.has(cacheKey)) {
                    this.setAvailableStock(this.availableStockCache.get(cacheKey) || []);
                    return;
                }

                this.getAllAvailableStock(this.companyBranchId, this.itemCatalogGroupId, isPositiveRange, cacheKey);
                break;
            }
        }
     }
      /**
   * @name getAllAvailableStock
   * @param {number} companyBranchId
   * @param {number} itemCatalogGroupId
   * @param {number} isPositiveRange
   * @returns
   * @memberof SharedService
   */
  getAllAvailableStock(companyBranchId: number, itemCatalogGroupId: number, isPositiveRange: boolean, cacheKey?: string) {
    if (this.loadingAllAvailableStock) {
        return;
    }
    this.loadingAllAvailableStock = true;
    this.sharedService.getAllAvailableStock(companyBranchId, itemCatalogGroupId, isPositiveRange)
        .then((response: any) => {
            if (response.data.completed) {
            this.checkRange();
            this.loadingAllAvailableStock = false;
            const payload = response.data.payload?.availableStock || [];
            if (cacheKey) {
                this.availableStockCache.set(cacheKey, payload);
            }
            this.setAvailableStock(payload);
            } else {
                this.loadingAllAvailableStock = false;
                console.error(response);
            }
        })
        .catch(error => {
            this.loadingAllAvailableStock = false;
            console.log(error);

        });

 }
  /**
     * @name setCurrentStock
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setAvailableStock(dataSource: any[]) {
        this.previousStockMap.clear();
        if (!this.previousStock) {
            this.refreshGridBadges();
            return;
        }

        if (!Array.isArray(dataSource) || !dataSource.length) {
            this.refreshGridBadges();
            return;
        }

        dataSource.forEach((data) => {
            const key = this.buildCellKey(data?.sph, data?.addf);
            const qty = Number(data?.availableStock ?? data?.available ?? data?.qty);
            if (!Number.isFinite(qty)) {
                return;
            }
            this.previousStockMap.set(key, qty);

            if (this.isPreviousStockValueSetInput) {
                this.applyStockValueToGrid(data?.sph, data?.addf, qty);
                this.getRangeValues(qty, Number(data?.addf), Number(data?.sph));
            }
        });

        this.refreshGridBadges();
    }
 /**
   * @name validateBarcodeRequestRange
   * @param {number} itemCatalogGroupId
   * @param {number} itemTypeMasterId
   * @param {number} focalId
   * @param {number} sphmin
   * @param {number} sphmax
   * @param {number} cylmin
   * @param {number} cylmax
   * @param {*} payload
   * @returns
   * @memberof SharedService
   */
  validateBarcodeRequestRange(payload) {
    this.rangeLoading = true;
     this.sharedService.validateBarcodeRequestRange(payload)
         .then((response: any) => {
             if (response.data.completed && response.data.payload.length > 0) {
                 this.rangeLoading = false;
                 console.log('validateBarcodeRequestRange', response.data.payload);
                 this.setBarCodeRange(response.data.payload);
             } else {
                 this.rangeLoading = false;
                 console.error(response);
             }
         })
         .catch(error => {
             this.rangeLoading = false;
             console.log(error);

         });

 }
    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description setInventoryFormData
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    // setInventoryFormData(dataSource) {
    //     this.templist = Array.isArray(dataSource) ? dataSource : null;
    //     this.seedFromExistingPayload(this.templist || []);
    //     this.totalQTY = this.sharedService.getTotal(this.rangeStockListPayload, 'vendorItemCode');
    // }
    setInventoryFormData(dataSource) {
        this.templist = Array.isArray(dataSource) ? dataSource : null;
        this.seedFromExistingPayload(this.templist || []);
        this.totalQTY = this.sharedService.getTotal(
            this.rangeStockListPayload,
            'vendorItemCode'
        );

        // ✅ SAFE: data injection completed
        setTimeout(() => {
            this.addGrid?.instance?.refresh();
        }, 0);
    }


     /**
     * @name setInventoryFormData
     * @requires params SPH_RANGE or CYL_RANGE
     * @returns value
     */
    setBarCodeRange(dataSource) {
        this.SPH_RANGE.forEach((sph, sphIndex) => {
            this.ADD_RANGE.forEach((addf, index) => {
                dataSource.forEach(data => {
                let s = sph.toString().replace('-','');
                let add = addf.toString().replace('-', '');
                let sp = data.sph.toFixed(2).replace('-', '');
                let ad = data.addf.toFixed(2).replace('-', '');
                $('table tr td #input-' + sphIndex + '-' + index).attr('disabled', 'disabled');
                    if (sp == s && ad == add) {
                        setTimeout(() => {
                                console.log('data.status', data.Status)
                                 $('table tr td #input-' + sphIndex + '-' + index).removeAttr('disabled');
                        }, 10);
                    } 
                });
            });
        });
    }
    toggleGenerateBtn() {
        if (((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).length > 0) {
            const sph_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('min').value;
            const sph_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(0).get('max').value;
            const add_min = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('min').value;
            const add_max = ((this.sectionsArray as FormArray).at(0).get('childern') as FormArray).at(1).get('max').value;
            if ((sph_min && sph_max && add_min && add_max) ||
                (sph_min === 0 && sph_max && add_min === 0 && add_max) ||
                (sph_min === 0 && sph_max && add_min && add_max) ||
                (add_min === 0 && add_max && sph_min && sph_max)) {
                return true;
            } else {
                return false;
            }
        }
    }

    /**
     // tslint:disable-next-line:no-redundant-jsdoc
     * @description destroy component
     */
    // Keep grid state in sync when typing in DevExtreme cell
    onCellInput(val: any, addVal: any, sphVal: any, rowIndex: number, colIndex: number) {
        try { if (this.gridData && this.gridData[rowIndex]) this.gridData[rowIndex]['add_' + colIndex] = val; } catch { }
        this.getRangeValues(val, addVal, sphVal);
    }
    /**
     * Seed current gridData cells from an existing payload (edit mode),
     * then rebuild the internal rangeStockListPayload to stay in sync.
     */
    private seedFromExistingPayload(source: any[] = []) {
        // Need ranges and grid rows to be present
        if (!Array.isArray(this.SPH_RANGE) || !Array.isArray(this.ADD_RANGE) || !Array.isArray(this.gridData)) {
            return;
        }

        // Build a lookup: key (SPH|ADD) -> detail row
        const map = new Map<string, any>();
        // Prefer incoming source
        for (const d of source || []) {
            if (d == null) continue;
            const key = this.makeKey(d.sph, (d.addf ?? d.add ?? d.addF));
            if (!map.has(key)) map.set(key, d);
        }
        // Fallback to any other known sources (staged or from dataSource)
        for (const d of this.existingSources()) {
            if (d == null) continue;
            const key = this.makeKey(d.sph, (d.addf ?? d.add ?? d.addF));
            if (!map.has(key)) map.set(key, d);
        }

        // Fill gridData cells
        for (let r = 0; r < this.gridData.length; r++) {
            const row = this.gridData[r];
            const sph = row?.sph;
            for (let c = 0; c < this.ADD_RANGE.length; c++) {
                const addf = this.ADD_RANGE[c];
                const key = this.makeKey(sph, addf);
                const found = map.get(key) || {};
                const code = this.normalizeCode(
                    found.vendorItemCode ?? found.code ?? found.barcode ?? found.vendorBarCode
                );
                row['add_' + c] = code || '';
            }
        }

        // Rebuild payload from the visible grid snapshot so ids are preserved
        this.rebuildDetailsFromGrid();

        // Refresh grid if available
        try { this.addGrid?.instance?.refresh?.(); } catch { }
    }


    private applyStockValueToGrid(sph: number | string, addf: number | string, value: number | string) {
        if (!this.gridData?.length || !Array.isArray(this.ADD_RANGE)) {
            return;
        }
        const rowIndex = this.gridData.findIndex(row => Number(row.sph) === Number(sph));
        if (rowIndex === -1) {
            return;
        }
        const addIndex = this.ADD_RANGE.findIndex(r => Number(r) === Number(addf));
        if (addIndex === -1) {
            return;
        }
        const field = `add_${addIndex}`;
        const normalized = value == null ? '' : String(value);
        this.gridData[rowIndex][field] = normalized;
        try {
            this.addGrid?.instance?.cellValue(rowIndex, field, normalized);
        } catch { }
    }

    private buildCellKey(sph: number | string, addf: number | string): string {
        return this.makeKey(sph, addf);
    }

    // private refreshGridBadges() {
    //     try {
    //         this.addGrid?.instance?.refresh();
    //     } catch { }
    // }
    private refreshGridBadges() {
        try {
            this.addGrid?.instance?.repaint();
        } catch { }
    }


    private renderBadge(cell: HTMLElement, className: string, value?: number | null) {
        if (!cell) {
            return;
        }
        const existing = cell.querySelector<HTMLElement>(`.${className}`);
        if (value == null || Number.isNaN(value)) {
            existing?.remove();
            return;
        }

        cell.style.position = 'relative';
        if (existing) {
            existing.textContent = `${value}`;
            return;
        }

        const badge = document.createElement('span');
        badge.className = className;
        badge.textContent = `${value}`;
        cell.appendChild(badge);
    }

    private parseAddField(field: string): number {
        const match = field.match(/^add_(\d+)$/);
        return match ? Number(match[1]) : -1;
    }

    /** Normalise decimal keys to 2dp for consistent matching (4.5 === 4.50). */
    private normN(n: any): number {
        const v = Number(n);
        return Number.isFinite(v) ? Number(v.toFixed(2)) : NaN;
    }

    /** Build stable key for ADD grid cells (SPH|ADD). */
    private makeKey(sph: any, addf: any): string {
        return `${this.normN(sph)}|${this.normN(addf)}`;
    }

    /** Pull every possible “existing details” source (edit-mode tolerant). */
    private existingSources(): any[] {
        const fromRange = Array.isArray(this.dataSource?.rangeStockListPayload) ? this.dataSource.rangeStockListPayload : [];
        const fromDetail = Array.isArray(this.dataSource?.vendorItemCatalogDetail) ? this.dataSource.vendorItemCatalogDetail : [];
        const fromTemp = Array.isArray((this as any).templist) ? (this as any).templist : [];
        const staged = Array.isArray(this.rangeStockListPayload) ? this.rangeStockListPayload : [];
        // order matters: newest first
        return [...staged, ...fromRange, ...fromDetail, ...fromTemp];
    }

    /** Map "SPH|ADD" -> existing row (with ids) using normalised numbers. */
    private existingDetailLookup(): Map<string, any> {
        const map = new Map<string, any>();
        for (const d of this.existingSources()) {
            const key = this.makeKey(d.sph, (d.addf ?? d.add ?? d.addF));
            if (!map.has(key)) map.set(key, d);
        }
        return map;
    }
    private parseQty(value: any): number | null {
        if (value === '' || value === null || value === undefined) {
            return null;
        }
        const parsed = Number(value);
        return Number.isNaN(parsed) ? null : parsed;
    }

    /** Tidy any input into a clean barcode string. */
    private normalizeCode(v: any): string {
        return (v ?? '').toString().trim();
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        // this.subscription.unsubscribe();
    }

    private isPositiveRange(): boolean {
        const sections = this.sectionsArray as FormArray;
        const children = sections?.at(0)?.get('childern') as FormArray;
        const maxControl = children?.at(0)?.get('max');
        const maxValue = maxControl && maxControl.value != null ? Number(maxControl.value) : NaN;
        return Number.isFinite(maxValue) ? maxValue > 0 : false;
    }

    private buildAvailableStockCacheKey(companyBranchId: number, itemCatalogGroupId: number, isPositiveRange: boolean): string {
        return `${companyBranchId || 0}|${itemCatalogGroupId || 0}|${isPositiveRange ? 1 : 0}`;
    }
    // ✅ Safe numeric parse for a cell value (handles "", null, "4", 4, "4.00")
    private toNumber(val: any): number {
        if (val === null || val === undefined) return 0;
        const s = String(val).trim();
        if (!s) return 0;

        // If user types non-numeric, ignore in total
        const n = Number(s);
        return Number.isFinite(n) ? n : 0;
    }

    // ✅ Compute total from current gridData (dynamic add_* columns)
    private computeGrandTotalFromGrid(): number {
        let total = 0;

        const colCount = this.ADD_RANGE?.length || 0;
        const rows = this.gridData || [];

        for (const row of rows) {
            for (let c = 0; c < colCount; c++) {
                total += this.toNumber(row['add_' + c]);
            }
        }

        return total;
    }

    // ✅ DevExtreme custom summary hook (footer total)
    calculateCustomSummary = (options: any) => {
        if (options.name !== 'grandTotal') return;

        if (options.summaryProcess === 'start') {
            options.totalValue = 0;
        }

        if (options.summaryProcess === 'finalize') {
            options.totalValue = this.computeGrandTotalFromGrid();
        }
    };

    // ✅ Force footer to refresh after initial data bind / edit fetch
    onGridContentReady(e: any) {
        // Recalculate summary after grid is fully rendered
        setTimeout(() => {
            try {
                e?.component?.refresh?.();          // ensures summary recalculates
                e?.component?.repaint?.();
            } catch { }
        }, 0);
    }

}
